
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-public-profile-petsitter/[customer-id]",
      function () {
        return require("private-next-pages/view-public-profile-petsitter/[customer-id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-public-profile-petsitter/[customer-id]"])
      });
    }
  